import Cookies from 'js-cookie';
import { headerHeight } from '../helpers';

(function ($) {
  const $announcementBar = $('.announcement-bar');
  const isCollapsible = $announcementBar.attr('data-announcement-collapsible');
  const $header = $('header.site-header');
  const $searchPopup = $header.find('.header__search-popup');
  const announcementReadyEvent = new CustomEvent('dAgency:announcement-ready');
  const registerAnnoucementEvent = function() {
    $(document).ready(function(){
      document.dispatchEvent(announcementReadyEvent);
    });
  }

  if (isCollapsible) {
    if (!Boolean(Cookies.get('announcement_hide'))) {
      $announcementBar.slideDown(250, function () {
        $searchPopup.css('top', headerHeight() + 'px');
        registerAnnoucementEvent();
      });
    } else {
        registerAnnoucementEvent();
    }
  } else {
    registerAnnoucementEvent();
    Cookies.remove('announcement_hide');
  }

  if ($announcementBar.length > 0 && $announcementBar.children().length > 0) {
    const $firstAnnouncement = $announcementBar.find('.announcement-bar__announcement').first();
    const announcementHeight = parseInt($firstAnnouncement.innerHeight());
    $announcementBar.css('height', announcementHeight + 'px');


    if (isCollapsible) {


      const announcementBar = $announcementBar.get(0); // Starting moving away from jQuery
      const announcementCloseBtn = announcementBar.querySelector('[data-announcement-close]');
      const hideFor = parseInt(announcementBar.getAttribute('data-announcement-collapsible-duration'));

      announcementCloseBtn.addEventListener('click', e => {
        $announcementBar.slideUp(250, function () {
          $searchPopup.css('top', headerHeight() + 'px');
          document.dispatchEvent(announcementReadyEvent);
        });

        const cookieOptions = hideFor ? { expires: hideFor } : null;
        Cookies.set('announcement_hide', true, cookieOptions);
      });
    }

    if ($announcementBar.find('[data-announcement-index]').length > 1) {
      $firstAnnouncement.clone().attr('data-announcement-index', $announcementBar.children().length).appendTo($announcementBar);
      const $announcements = $announcementBar.find('.announcement-bar__announcement');

      $announcements.each(function () {
        $(this).css('height', announcementHeight + 'px');
      });

      var activeIndex = 0;
      setInterval(() => {
        activeIndex++;
        if (!$announcementBar.find('[data-announcement-index="' + activeIndex + '"]').length > 0) {
          $announcements.each(function () {
            var transition = $(this).css('transition');
            $(this).css('transition', '0s');
            $(this).css('transform', 'translate3d(0, 0, 0)');

            // setTimeout is used to move the callback out of the stack and into the queue.
            // We need to use the queue to ensure that the transition is restored only after
            // the transition is complete.
            setTimeout(() => {
              $(this).css('transition', transition);
            }, 0);
          });

          activeIndex = 1;
        }

        // setTimeout is used to move the callback out of the stack and into the queue.
        // We need to use the queue to ensure that the movement of the elements comes
        // after the position reset.
        setTimeout(() => {
          $announcements.each(function () {
            if ($announcementBar.data('direction') === 'horizontal') {
              $(this).css('transform', 'translate3d(calc(' + activeIndex + ' * -100%), 0, 0)');
            } else {
              $(this).css('transform', 'translate3d(0, calc(' + activeIndex + ' * -100%), 0)');
            }
          });
        }, 0);
      }, 5000);
    }
  }
})(jQuery);
